export default __webpack_public_path__ + "static/hero-tablet-9bda21703e1ebbf7062141df5eb5cbce.png";